import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AnalyticEventName, AnalyticsService, BreakpointService } from '@services';
import { AppRoutes } from '@app-routes';
import {
  OPEN_CONTRACT_ACTION
} from '../../../components/dashboard/settings/components/settings-business/settings-business.constants';

@Component({
  selector: 'app-contract-button',
  templateUrl: './contract-button.component.html',
  styleUrls: ['./contract-button.component.scss'],
})
export class ContractButtonComponent {
  readonly isMobile$ = this.breakpointService.isMobile$;
  readonly businessSettingsRouteSegments = [AppRoutes.dashboard, AppRoutes.settings, AppRoutes.business];

  constructor(
    private breakpointService: BreakpointService,
    private router: Router,
    private analyticsService: AnalyticsService,
  ) {
  }

  handleClick(): void {
    this.analyticsService.track({ name: AnalyticEventName.CLICK_MAKE_CONTRACT_HEADER });

    if (this.isSameRoute()) {
      this.router.navigate([], { queryParams: { action: OPEN_CONTRACT_ACTION }, replaceUrl: true });
    } else {
      this.router.navigate(this.businessSettingsRouteSegments, { queryParams: { action: OPEN_CONTRACT_ACTION } });
    }
  }

  private isSameRoute(): boolean {
    const targetPath = '/' + this.businessSettingsRouteSegments.join('/');
    return this.router.url.split('?')[0] === targetPath;
  }
}
